import React from 'react';
import { Card, CardContent, Divider, Box, Typography, Icon } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function ComplexStatisticsCard({
  color = 'primary',
  icon,
  title,
  count,
  percentage,
  children,
  onClick,
}) {
  const theme = useTheme();
  const bgColor = theme.palette[color]?.main || theme.palette.primary.main;
  const contrast = theme.palette.getContrastText(bgColor);

  return (
    <Card onClick={onClick} sx={{ cursor: onClick ? 'pointer' : 'default', 
      '&:hover': {
        boxShadow: '0 4px 4px rgba(0,0,0,0.15)',
        backgroundColor: theme.palette.action.hover,
      },
     }}>
      <Box display="flex" alignItems="center" py={3} px={3}>       
        <Box flexGrow={1} textAlign="left" lineHeight={1.25} ml={2}>
          <Typography variant="button" color="text.secondary" fontWeight={600} sx={{ whiteSpace: 'normal' }}>
            {title}
          </Typography>
          {count !== undefined && <Typography variant="h4">{count}</Typography>}
        </Box>
         <Box
          sx={{
            backgroundColor: bgColor,
            color: contrast,
            borderRadius: 1,
            width: '4rem',
            height: '3.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
           
          }}
        >
          {React.isValidElement(icon) ? (
            icon
          ) : (
            <Icon fontSize="medium" >{icon}</Icon>
          )}
        </Box>
      </Box>
      {(percentage || children) && <Divider />}
      {percentage && (
        <Box pb={2} px={2}>
          <Typography component="p" variant="button" color="text.secondary" display="flex">
            <Typography
              component="span"
              variant="button"
              fontWeight="bold"
              color={percentage.color || 'success'}
              sx={{ mr: 0.5 }}
            >
              {percentage.amount}
            </Typography>
            {percentage.label}
          </Typography>
        </Box>
      )}
      {children && <CardContent>{children}</CardContent>}
    </Card>
  );
}
